export enum Table {
	BLOOD_PRESSURE = 'blood_pressure',
	WEIGHT = 'weight',
	HEIGHT = 'height',
	WAISTLINE = 'waistline',
	BLOOD_GLUCOSE = 'blood_glucose',
	STEPS = 'step_count',
	BREATHING_RATE = 'breathing_rate',
	OXYGEN_SATURATION = 'oxygen_saturation',
	SLEEP = 'sleep',
	HEMOGLOBIN = 'hemoglobin',
	HEMOGLOBIN_A1C = 'hemoglobinA1C',
	STRESS_LEVEL = 'stress_level',
	ACTIVE_ENERGY = 'active_energy',
	DISTANCE_WALKING_RUNNING = 'distance_walking_running',
	WORKOUT = 'workout',
	MULTIPLE = 'multiple',
	QUESTIONNAIRE_RESULTS = 'questionnairesResults',
	QUESTIONNAIRE_RESULTS_LATAM_BABY = 'questionnairesResultsLatamBaby',
}
